export const tag = 'm060c110ctaalternative';
export const load = async () => {
    const { M060C110CtaAlternativeComponent } = await import('./m060-c110-cta-alternative.component');
    return {
        component: M060C110CtaAlternativeComponent,
    };
};
